/// <amd-module name="Wiki/ViewCommon/Constants" />
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

// Wiki action ids (in lower case)
export const enum ActionIds {
    Compare = "compare",
    Edit = "edit",
    History = "history",
    Publish = "publish",
    View = "view",
    Update = "update"
}

export const enum FormatConstants {
    MDFormat = ".md"
}

export const enum RepoConstants {
    AttachmentsFolder = "/.attachments",
    RootPath = "/",
    PathSeparator = "/"
}

export const enum TemplateConstants {
    Identifier = "template",
    TemplateDirectory = "/.templates",
    Marker = ":",
    TemplateOpenTag = "container_template_open",
    TemplateCloseTag = "container_template_close"
}

export namespace UrlEscapeConstants {
    export const HyphenEncoding = "%2D";
    export const HyphenEncodingRegExp = /%2D/g;
    export const HyphenRegExp = /-/g;
    export const SpaceEncoding = "%20";
    export const SpaceRegExp = /\ /g;
    export const OpeningBracesEncoding = "\\(";
    export const OpeningBracesRegExp = /\(/g;
    export const ClosingBracesEncoding = "\\)";
    export const ClosingBracesRegExp = /\)/g;
    export const ContiguousHyphenRegExp = /-{2,}/g;
}

// We need this as dictionary as we need to iterate on the keys
export const UrlConstants: { [key: string]: string } = {
    AnchorParam: "anchor",
    ActionParam: "_a",
    IsSubPageParam: "isSubPage",
    PagePathParam: "pagePath",
    PageIdParam: "pageId",
    FriendlyNameParam: "friendlyName",
    ProjectParam: "project",
    WikiIdentifierParam: "wikiIdentifier",
    WikiVersionParam: "wikiVersion",
    ShouldScrollToCommentsParam: "shouldScrollToComments"
};

export const enum SpecialChars {
    Space = " ",
    Hyphen = "-"
}

export const enum DragEventsSource {
    WikiTreeNode = "WikiTreeNode"
}

export namespace PathConstants {
    export const ResourceNameInvalidCharacters = ["/", "\\"];
    export const PageNameReservedCharacters = ["#"];
    export const MaximumPagePathLength = 235;
    export const AttachmentNameReservedCharacters = ["#"];
    export const GitIllegalSpecialCharsRegExp = [/\:/g, /\?/g, /\*/g, /\</g, /\>/g, /\-/g, /\|/g, /\"/g];
    export const GitIllegalSpecialChars = [":", "?", "*", "<", ">", "-", "|", '"'];
    export const GitIllegalSpecialCharEscapes = ["%3A", "%3F", "%2A", "%3C", "%3E", "%2D", "%7C", "%22"];
    export const GitIllegalSpecialCharEscapesRegExp = [/%3A/g, /%3F/g, /%2A/g, /%3C/g, /%3E/g, /%2D/g, /%7C/g, /%22/g];
    export const AllowedAttachmentFileTypes = (pageContext: IVssPageContext) => [
        ".CS",
        ".CSV",
        ".DOC",
        ".DOCX",
        ".GIF",
        ".GZ",
        ".HTM",
        ".HTML",
        ".ICO",
        ".JPEG",
        ".JPG",
        ".JSON",
        ".LYR",
        ".MD",
        ".MOV",
        ".MP4",
        ".MPP",
        ".MSG",
        ".PDF",
        ".PNG",
        ".PPT",
        ".PPTX",
        ".PS1",
        ".RAR",
        ".RDP",
        ".SQL",
        ".TXT",
        ".VSD",
        ".VSDX",
        ".XLS",
        ".XLSX",
        ".XML",
        ".ZIP",
        ...(isFeatureFlagEnabled(pageContext, AttachSvgFileFF, false) ? [".SVG"] : [])
    ];
}

export const AttachSvgFileFF = "Wiki.AttachSvgFile";

export const WikiPageCommentsFF = "Wiki.WikiPageComments";

export const WikiDataProviderContributionId = "ms.vss-wiki-web.wiki-data-provider";

export const RepoServiceContributionId = "ms.vss-code.version-control";
